<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-12 nopads">
        <member-item
            v-for="member in uniqueMembers"
            :key="member.id"
            :member="member"/>
    </div>
</template>

<script>
    import MemberItem from "../member/MemberItem";
    export default {
        name: "found-member-list",
        components: {MemberItem},
        props: {
            members: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        watch: {
            members: function() {
                this.$forceUpdate()
            }
        },
        computed: {
            uniqueMembers() {
                return this.members.reduce((seed, member) => {
                    return Object.assign(seed, {
                        [member.id]: member
                    });
                }, {});
            }
        }
   }
</script>
